import { queryOptions } from '@tanstack/react-query';

import { loadPoll, loadPollDetails } from '@apis/polls';

export const getPollQuery = (id: string) =>
  queryOptions({
    queryKey: ['poll', id],
    queryFn: ({ signal }) => loadPoll(id, signal),
    enabled: !!id,
  });

export const getPollDetailQuery = (pollId: string) =>
  queryOptions({
    queryKey: ['poll-answers', pollId],
    queryFn: ({ signal }) => loadPollDetails(pollId, signal),
    enabled: !!pollId,
  });
